import { Injectable, NgModule } from '@angular/core';
import { catchError, Observable, switchMap, of } from 'rxjs';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppConstant } from '../../app.constants'
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
    constructor(private _appConstant: AppConstant, private msalService: MsalService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.isTokenExpired()) { // Check if the token is expired
            this.msalService.initialize(); // Initialize the msal service
            if (this.msalService.instance.getAllAccounts().length > 0) {
                const account = this.msalService.instance.getAllAccounts()[0];
                const renewIdTokenRequest = {
                    scopes: ["user.read"],
                    account: account,
                    forceRefresh: true
                }

                // Refresh the token by acquiring a new one silently
                return this.msalService.acquireTokenSilent(renewIdTokenRequest).pipe(
                    switchMap((response: AuthenticationResult) => {
                        localStorage.setItem("msal.idtoken", response.idToken);
                        const reqHeader = this.header(req);
                        return next.handle(reqHeader);
                    }),
                    catchError((error: HttpErrorResponse) => {
                        console.error('Token refresh failed', error);
                        this.msalService.loginRedirect();
                        return of(null) as Observable<HttpEvent<any>>;
                    })
                );
            } else {
                this.msalService.loginRedirect();
            }
        } else {
            const reqHeader = this.header(req);
            return next.handle(reqHeader);
        }
      }

    header(req) { 
        let methodName = req.url.split('/')[5];
        if(methodName && methodName.includes('?')){
            methodName = methodName.split('?')[0];
        }
        if (!methodName || methodName.includes("-")) {
            methodName = req.url.split('/')[4];
            if(methodName && methodName.includes('?')){
                methodName = methodName.split('?')[0];
            }
            if (!methodName) {
                methodName = req.url.split('/')[3];
            }
        }
        let isMethodExist = false;
        let isFileUploadMethod = false;

        
        this._appConstant.ListOfMethod.forEach((val) => {
            if (val === methodName) {
                isMethodExist = true;
            }
        });
        this._appConstant.FileUploadListMethodsWithProgram.forEach((val) => {
            if (val === methodName) {
                isFileUploadMethod = true;
            }
        });
        if (!isMethodExist) {
            return req.clone({
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Authorization': `Bearer ${localStorage.getItem('msal.idtoken')}`
                })
            });
        } else if (isFileUploadMethod) {
            return req.clone({
                headers: new HttpHeaders({
                    //'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundaryIIuYgJ1rN9Fq8gsl',
                    //'Content-Type': 'application/x-www-form-urlencoded' ,
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'program-id': this._appConstant.programId ? this._appConstant.programId : this._appConstant.selectedProgramId,
                    'Authorization': `Bearer ${localStorage.getItem('msal.idtoken')}`
                })
            });
        }
        else {
            return req.clone({
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'program-id': this._appConstant.programId ? this._appConstant.programId : this._appConstant.selectedProgramId,
                    'Authorization': `Bearer ${localStorage.getItem('msal.idtoken')}`
                })
            });
        }
    }

    isTokenExpired(): boolean {
        let isExpired = false;
        if (this.msalService.instance.getAllAccounts().length > 0) {
            const account = this.msalService.instance.getAllAccounts()[0];
            if (account && account.idTokenClaims && account.idTokenClaims.exp) {
                localStorage.setItem("msal.idtoken", account.idToken);
                var idTokenExpiryDatetime = new Date(account.idTokenClaims.exp * 1000);
                var currentDatetime = new Date();
                if (idTokenExpiryDatetime.getTime() < currentDatetime.getTime()) {
                    isExpired = true;
                }
            }
        }
        return isExpired;
    }
}


@NgModule({
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true }
    ]
})
export class InterceptorModule { }